import { jsx } from "react/jsx-runtime";
import i18n from "../../../../i18n/index.js";
import { APP_SWITCHER_DESKTOP_BTN_ID } from "./constants.js";
import "../../../../i18n/translations/en.js";
import "../../../../i18n/translations/es.js";
import "../../../../i18nInstance-89725fcb.js";
const FOCUS_MODAL_OPTIONS_APP_SWITCHER = {
  elementId: APP_SWITCHER_DESKTOP_BTN_ID,
  uniqueId: "jVwGRXb7RjOVqUXQXdN7V",
  props: {
    title: i18n.t("APP_SWITCHER:FOCUS_MODAL_TITLE"),
    Body: /* @__PURE__ */ jsx("div", { className: "text-inverse_secondary", children: i18n.t("APP_SWITCHER:FOCUS_MODAL_BODY") }),
    placement: "right-start"
  }
};
export {
  FOCUS_MODAL_OPTIONS_APP_SWITCHER
};
//# sourceMappingURL=flashAppSwitcherFocusModal.js.map
